// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--rXjj5","text":"a10a3f92e9--text--G3lxu","info-icon":"a10a3f92e9--info-icon--PKg0J","rate":"a10a3f92e9--rate--A2Xem"};